// 3rd party imports
import * as React from 'react';
import * as fetch from 'isomorphic-fetch';

//bernie
import { ContextStore, ExperimentStore, PageStore } from 'bernie-core';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

// uitk
import { ESSAdapter, TypeaheadSelection, UitkTypeahead } from 'uitk-react-typeahead';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkTextArea, UitkTextInput } from 'uitk-react-input';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkToast } from 'uitk-react-toast';
import { UitkSelect } from 'uitk-react-select';
import { UitkToggleSwitch } from 'uitk-react-switch';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';

//utils
import { hasValidDateRange, isValidDateFormat } from '../../../../util/DatesUtil';

// components
import Loader from '../../common/loader';
import { RoomComponent } from './room-component';
import { ChildComponent } from './child-component';
import { LinkStore } from 'stores';

export interface ExamplePropsHIS {
  context: ContextStore;
  logger?: Logger;
  page?: PageStore;
  experiment?: ExperimentStore;
  startDate?: Date;
  endDate?: Date;
}

export interface ExampleStateHIS {
  date: string;
  hotelInfo: any;
  isHydrated: boolean;
  openVal: boolean;
}

export interface TypeaheadSelectionPropsHIS {
  data: TypeaheadDataPropsHIS;
  term: string;
}

interface HierarchyInfo {
  airport: Airport;
}

interface Airport {
  airportCode: string;
  airportId: string;
  metrocode: string;
  multicity: string;
}

export interface TypeaheadDataPropsHIS {
  regionId: string;
  originId: string;
  hierarchyInfo: HierarchyInfo;
  selectedLocation: string;
}

export interface HotelLobDetailsProps {
  link: LinkStore;
}

export class HotelLobDetails extends React.Component<HotelLobDetailsProps, any> {
  public onCloseRef;

  public constructor(props) {
    super(props);
    this.state = { value: props.value };
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleUrlOpen = this.handleUrlOpen.bind(this);
    this.onDaysInFutureChange = this.onDaysInFutureChange.bind(this);
    this.onLengthofStayChange = this.onLengthofStayChange.bind(this);
    this.onRoomCountChange = this.onRoomCountChange.bind(this);
    this.onAdultCountChange = this.onAdultCountChange.bind(this);
    this.onChildCountChange = this.onChildCountChange.bind(this);
    this.onAgeChange = this.onAgeChange.bind(this);
    this.renderRoom = this.renderRoom.bind(this);
    this.handleHotelId = this.handleHotelId.bind(this);
    this.copyToClipBoard = this.copyToClipBoard.bind(this);
    this.handleDateField = this.handleDateField.bind(this);
    this.state = {
      startDate: '',
      endDate: '',
      openVal: false,
      daysInFuture: '',
      lengthOfStay: '',
      roomStateChange: false,
      roomCount: 1,
      roomComponents: [],
      numAdults: {
        adultCount1: 1,
        adultCount2: 0,
        adultCount3: 0,
        adultCount4: 0,
        adultCount5: 0,
        adultCount6: 0,
        adultCount7: 0,
        adultCount8: 0,
      },
      numChild: {
        childCount1: 0,
        childCount2: 0,
        childCount3: 0,
        childCount4: 0,
        childCount5: 0,
        childCount6: 0,
        childCount7: 0,
        childCount8: 0,
      },
      childDetails: { child1: [], child2: [], child3: [], child4: [] },
      childAge1: [-1, -1, -1, -1, -1, -1],
      childAge2: [-1, -1, -1, -1, -1, -1],
      childAge3: [-1, -1, -1, -1, -1, -1],
      childAge4: [-1, -1, -1, -1, -1, -1],
      childAge5: [-1, -1, -1, -1, -1, -1],
      childAge6: [-1, -1, -1, -1, -1, -1],
      childAge7: [-1, -1, -1, -1, -1, -1],
      childAge8: [-1, -1, -1, -1, -1, -1],
      childStatus: false,
      childCount: 0,
      starRating: [],
      allAmenity: false,
      air_condition: false,
      fitness: false,
      speed: false,
      all_inclusive: false,
      parking: false,
      pets: false,
      business_services: false,
      green: false,
      room_services: false,
      breakfast: false,
      hairdryer: false,
      spa: false,
      errors: { hotelId: '', dates: '' },
      error: false,
      childComponent1: [],
      childComponent2: [],
      childComponent3: [],
      childComponent4: [],
      childComponent5: [],
      childComponent6: [],
      hotelId: '',
      copyStatus: false,
      isLoading: false,
      hideDateField: false,
      copyMessage: "Sorry! you don't have a deeplink to copy",
    };
  }

  public handleChange(e) {
    this.setState({ value: e.target.value });
  }

  public handleDateField = (event) => {
    this.setState({
      [event.currentTarget.id]: event.currentTarget.checked,
      startDate: '',
      endDate: '',
      lengthOfStay: '',
      daysInFuture: '',
    });
  };

  public handleDatesChange = (event) => {
    const errors1 = this.state.errors;
    errors1['dates'] = '';
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  public validateDates(name: string) {
    const { startDate, endDate } = this.state;
    if ((!startDate && name === 'startDate') || (!endDate && name === 'endDate')) {
      return;
    }

    if (name === 'startDate' && !isValidDateFormat(startDate)) {
      return 'Please enter valid Check in date in the format mm/dd/yyyy';
    }
    if (name === 'endDate' && !isValidDateFormat(endDate)) {
      return 'Please enter valid Check out date in the format mm/dd/yyyy';
    }
  }

  public renderDaysInFutureAndLengthOfStay = () => {
    const days = ['', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];

    return days.map((day) => {
      return (
        <option key={day} value={day}>
          {day}
        </option>
      );
    });
  };

  public renderRoomCount = () => {
    const rooms = [1, 2, 3, 4, 5, 6, 7, 8];
    let opt;

    return rooms.map((room) => {
      if (room > 1) {
        opt = (
          <option key={room} value={room}>
            {room} Rooms
          </option>
        );
      } else {
        opt = (
          <option key={room} value={room}>
            {room} Room
          </option>
        );
      }

      return opt;
    });
  };

  public onAdultCountChange = (event) => {
    const adultId = event.target.getAttribute('id');
    const { value } = event.target;
    const adultArray = this.state.numAdults;
    adultArray[adultId] = Number(value);
    this.setState({
      numAdults: adultArray,
    });
  };

  public onRoomCountChange = (event) => {
    let { value } = event.target;
    let statusChange = false;
    if (value > 1) {
      statusChange = true;
    }
    this.setState({
      roomCount: value,
      roomStateChange: statusChange,
    });
    const rooms = [];
    for (let i = 1; i < value; i++) {
      rooms.push(
        <RoomComponent
          onAdultCountChange={this.onAdultCountChange}
          onChildCountChange={this.onChildCountChange}
          roomCount={i + 1}
          childComponent={this.state[`childComponent${i + 1}`]}
        />,
      );
    }

    for (let i = Number(value) + 1; i <= 6; i++) {
      this.setState({
        [`childComponent${i}`]: [],
      });
    }
    this.setState({
      roomComponents: rooms,
    });
    const adultArray = this.state.numAdults;
    if (adultArray[`adultCount${value}`] === 0) {
      adultArray[`adultCount${value}`] = 1;
    }

    const childAgeArray = [...this.state[`childAge${value}`]];
    if (childAgeArray === []) {
      for (let i = 0; i < 6; i++) {
        childAgeArray.push(0);
      }
    }
    // tslint:disable-next-line:no-eval
    value = Number(value) + 1;
    const childArray = this.state.numChild;
    for (let i = value; i <= 6; i++) {
      adultArray[`adultCount${i}`] = 0;
      childArray[`childCount${i}`] = 0;
      this.setState({
        [`childAge${i}`]: [-1, -1, -1, -1, -1, -1],
      });
    }
    this.setState({
      numAdults: adultArray,
      numChild: childArray,
    });
  };

  public renderRoom() {
    const temp = this.state.roomCount;

    const rooms = [];

    for (let i = 1; i < temp; i++) {
      rooms.push(
        <RoomComponent
          onAdultCountChange={this.onAdultCountChange}
          onChildCountChange={this.onChildCountChange}
          roomCount={i + 1}
          childComponent={this.state[`childComponent${i + 1}`]}
        />,
      );
    }

    this.setState({
      roomComponents: rooms,
      roomStateChange: true,
    });
    /*const rooms = [];
        for(let i=0;i<this.state.roomCount-1;i++) {
          rooms.push(this.state.roomComponents[i]);
        }
        this.setState({
          roomComponents: rooms,
          roomStateChange: true
        })*/
  }

  public onAgeChange(event) {
    const { value } = event.target;
    const childId = event.currentTarget.getAttribute('id');
    const idChar = childId.substring(9, childId.length);
    const roomNo = idChar.split('-')[0];
    const childNum = idChar.split('-')[1];
    const totalChild = idChar.split('-')[2];
    const childAge = this.state[`childAge${roomNo}`];
    childAge[childNum - 1] = value;
    this.setState({
      [`childAge${roomNo}`]: childAge,
    });
  }

  public onChildCountChange = (event) => {
    this.setState({
      roomStateChange: false,
    });
    const { value } = event.target;
    const childArray = [];
    const roomId = event.currentTarget.getAttribute('id');
    const roomNum = roomId.substring(11, roomId.length);
    const childAge = this.state[`childAge${roomNum}`];
    for (let i = 0; i < Number(value); i++) {
      childAge[i] = 0;
    }
    for (let i = Number(value); i < 6; i++) {
      childAge[i] = -1;
    }
    this.setState({
      childCount: value,
    });
    this.setState({
      [`childAge${roomNum}`]: childAge,
    });
    for (let i = 1; i <= value; i++) {
      childArray.push(
        <ChildComponent roomCount={roomNum} childCount={i} totalChild={value} onAgeChange={this.onAgeChange} />,
      );
    }
    this.setState(
      {
        [`childComponent${roomNum}`]: childArray,
      },
      () => this.renderRoom(),
    );

    const rooms = [];

    const childArray1 = this.state.numChild;
    const temp = this.state.roomCount;
    const childId = event.currentTarget.getAttribute('id');
    const childrenArray = this.state.numChild;
    const childId1 = 'childCount' + childId.substring(11, childId.length);
    childrenArray[childId1] = Number(value);
    this.setState({
      numChild: childrenArray,
    });

    for (let i = 1; i < temp; i++) {
      rooms.push(
        <RoomComponent
          onAdultCountChange={this.onAdultCountChange}
          onChildCountChange={this.onChildCountChange}
          roomCount={i + 1}
          childComponent={this.state[`childComponent${i + 1}`]}
        />,
      );
    }

    this.setState(
      {
        roomComponents: rooms,
        roomStateChange: true,
      },
      () => this.renderRoom(),
    );
  };

  public fetchData() {
    const destination = this.state.selectedLocation;
    const mainCategory = 'Hotels';
    const subCategory = 'hotelInfo';
    const numRoom = 1;
    const numAdult = this.state.value;
    const checkInDate = this.state.startDate;
    const checkOutDate = this.state.endDate;
    const formattedStarRating = [];
    const formattedStars = [];
    let starString = '';
    const starRatings = this.state.starRating;
    let formattedStarRatingString = '';
    if (starRatings !== [] && starRatings !== undefined && starRatings !== null) {
      starRatings.forEach((item) => {
        switch (item) {
          case '1-star':
            formattedStarRating.push('hotelClass=10');
            formattedStars.push('10');
            break;
          case '2-star':
            formattedStarRating.push('hotelClass=20');
            formattedStars.push('20');
            break;
          case '3-star':
            formattedStarRating.push('hotelClass=30');
            formattedStars.push('30');
            break;
          case '4-star':
            formattedStarRating.push('hotelClass=40');
            formattedStars.push('40');
            break;
          case '5-star':
            formattedStarRating.push('hotelClass=50');
            formattedStars.push('50');
            break;
        }
      });

      formattedStarRatingString = '';
      for (let i = 0; i < formattedStarRating.length; i++) {
        if (i === 0) {
          formattedStarRatingString = formattedStarRating[i];
          starString = `hotelSearch-Class=${formattedStars[i]}`;
        } else {
          formattedStarRatingString = formattedStarRatingString + `&${formattedStarRating[i]}`;
          starString = starString + `,${formattedStars[i]}`;
        }
      }
    }
    let param =
      `main-category=${mainCategory}&sub-category=${subCategory}&` + `hotelInfo-HotelID=${this.state.hotelId}`;
    if (checkInDate !== '' && checkOutDate !== '') {
      param = param + `&hotelInfo-CheckInDate=${checkInDate}&hotelInfo-CheckOutDate=${checkOutDate}`;
    }
    if (this.props.link.language) {
      param =
        param +
        `&hotelInfo-marketingParam=clickid&hotelInfo-marketingParamVal=&hotelInfo-passthroughParam=langid&hotelInfo-passthroughParamVal=${this.props.link.language}`;
    } else {
      param =
        param +
        `&hotelInfo-marketingParam=clickid&hotelInfo-marketingParamVal=&hotelInfo-passthroughParam=langid&hotelInfo-passthroughParamVal=1033`;
    }

    if (formattedStarRatingString !== '') {
      param = param + `&${starString}&${formattedStarRatingString}`;
    }

    let adultArrayString = '';

    const adultsArray = this.state.numAdults;
    if (adultsArray !== [] && adultsArray!) {
      let key = '';
      for (let i = 1; i <= this.state.roomCount; i++) {
        key = `adultCount${i}`;
        if (this.state.childCount <= 0) {
          if (i === 1) {
            adultArrayString = adultArrayString + `hotelInfo-NumAdult${i}=${adultsArray[key]}&hotelInfo-NumChild${i}=0`;
          } else {
            adultArrayString =
              adultArrayString + `&hotelInfo-NumAdult${i}=${adultsArray[key]}&&hotelInfo-NumChild${i}=0`;
          }
        } else {
          if (i === 1) {
            adultArrayString = adultArrayString + `hotelInfo-NumAdult${i}=${adultsArray[key]}`;
          } else {
            adultArrayString = adultArrayString + `&hotelInfo-NumAdult${i}=${adultsArray[key]}`;
          }
        }
      }
    }
    if (adultArrayString !== '') {
      param = param + `&hotelInfo-NumRoom=${this.state.roomCount}&${adultArrayString}`;
    }

    let child = '';
    let childCount = 0;
    if (this.state.childCount > 0) {
      let key = '';
      let key2 = '';
      for (let i = 1; i <= this.state.roomCount; i++) {
        key = `childCount${i}`;
        child = child + `&hotelInfo-NumChild${i}=` + this.state.numChild[key];
      }
      for (let i = 1; i <= this.state.roomCount; i++) {
        childCount = this.state.numChild[`childCount${i}`];
        for (let j = 0; j < childCount; j++) {
          key2 = this.state[`childAge${i}`];
          child = child + `&hotelInfo-Rm${i}child${j + 1}age=` + key2[j];
        }
      }
    }

    if (child !== '') {
      param = param + child;
    }

    let amenityFilterString = '';
    if (this.state.allAmenity) {
      amenityFilterString =
        `hotelSearch-AmenityFilter[]=27&hotelSearch-AmenityFilter[]=11&hotelSearch-AmenityFilter[]=19` +
        `&hotelSearch-AmenityFilter[]=30&hotelSearch-AmenityFilter[]=14&hotelSearch-AmenityFilter[]=17` +
        `&hotelSearch-AmenityFilter[]=12&hotelSearch-AmenityFilter[]=43&hotelSearch-AmenityFilter[]=13` +
        `&hotelSearch-AmenityFilter[]=16&hotelSearch-AmenityFilter[]=26&hotelSearch-AmenityFilter[]=15`;
    }
    if (this.state.daysInFuture !== '' && this.state.lengthOfStay !== '') {
      param =
        param + `&hotelInfo-daysInFuture=${this.state.daysInFuture}&hotelInfo-stayLength=${this.state.lengthOfStay}`;
    } else {
      const amenities = [
        this.state.air_condition,
        this.state.fitness,
        this.state.speed,
        this.state.all_inclusive,
        this.state.parking,
        this.state.pets,
        this.state.business_services,
        this.state.green,
        this.state.room_services,
        this.state.breakfast,
        this.state.hairdryer,
        this.state.spa,
      ];
      const amenityNumber = [27, 11, 19, 30, 14, 17, 12, 43, 13, 16, 26, 15];
      const amenityIndex = [];
      for (let i = 0; i < amenities.length; i++) {
        if (amenities[i]) {
          amenityIndex.push(i);
        }
      }
      if (amenityIndex.length > 0) {
        amenityFilterString = `hotelSearch-AmenityFilter[]=${amenityNumber[amenityIndex[0]]}`;
      }
      if (amenityIndex.length > 1) {
        for (let i = 1; i < amenityIndex.length; i++) {
          amenityFilterString = amenityFilterString + `&hotelSearch-AmenityFilter[]=${amenityNumber[amenityIndex[i]]}`;
        }
      }
    }
    if (amenityFilterString !== '') {
      param = param + `&${amenityFilterString}`;
    }

    if (this.props.link.channel === 'Commission Junction') {
      if (this.props.link.pid || this.props.link.sid) {
        param = param + `&hotelInfo-trackingParam=${this.props.link.channel}`;
      }
      if (this.props.link.pid && this.props.link.pid) {
        param = param + `&hotelInfo-pid=${this.props.link.pid}`;
      }
      if (this.props.link.sid && this.props.link.sid) {
        param = param + `&hotelInfo-sid=${this.props.link.sid}`;
      }
    }

    if (this.props.link.channel === 'PHG') {
      if (this.props.link.camRef || this.props.link.adRef || this.props.link.creativeRef || this.props.link.pubRef) {
        param = param + `&hotelInfo-trackingParam=${this.props.link.channel}`;
      }
      if (this.props.link.camRef && this.props.link.camRef) {
        param = param + `&hotelInfo-camref=${this.props.link.camRef}`;
      }
      if (this.props.link.adRef && this.props.link.adRef) {
        param = param + `&hotelInfo-adref=${this.props.link.adRef}`;
      }
      if (this.props.link.creativeRef && this.props.link.creativeRef) {
        param = param + `&hotelInfo-creativeref=${this.props.link.creativeRef}`;
      }
      if (this.props.link.pubRef && this.props.link.pubRef) {
        param = param + `&hotelInfo-pubref=${this.props.link.pubRef}`;
      }
    }

    const url = `/api/paandi/marketing-tools/geturl?${param}`;

    return fetch(url, {
      method: 'GET',
    })
      .then((res) =>
        res.text().then((response) => {
          return response;
        }),
      )
      .catch((err) => ({
        error: err,
      }));
  }

  public handleClick() {
    let isError = false;
    const errors1 = this.state.errors;
    if (this.state.hotelId === '' || this.state.hotelId === undefined) {
      isError = true;
      errors1['hotelId'] = 'Please select the hotel';
    }
    if (this.state.startDate === '' && this.state.endDate === '') {
      if (this.state.daysInFuture === '' && this.state.lengthOfStay === '') {
        isError = true;
        errors1['dates'] = 'Please enter your dates';
      }
    }
    if (!!this.state.startDate && !this.state.endDate) {
      isError = true;
      errors1['dates'] = 'Please enter Check out date';
    }
    if (!this.state.startDate && !!this.state.endDate) {
      isError = true;
      errors1['dates'] = 'Please enter Check in date';
    }
    if (
      !!this.state.startDate &&
      !!this.state.endDate &&
      !hasValidDateRange(this.state.startDate, this.state.endDate)
    ) {
      isError = true;
      errors1['dates'] = 'Please enter valid dates';
    }
    this.setState({
      error: isError,
      errors: errors1,
      message: isError ? 'Form contains errors! Please correct it and proceed' : '',
    });
    if (!isError) {
      this.setState({
        isLoading: true,
      });
      this.fetchData().then((data) => {
        this.setState({
          link: data.toString(),
          isLoading: false,
          copyMessage: 'Successfully copied the deeplink to clipboard',
        });
      });
    } else {
      window.scrollTo(0, 0);
    }
  }

  public handleUrlOpen() {
    window.open(this.state.link);
  }

  public copyToClipBoard() {
    const textField = document.createElement('textarea');
    textField.innerText = this.state.link;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    this.setState({
      copyStatus: true,
    });
  }

  public onDaysInFutureChange = (event) => {
    const error1 = this.state.errors;
    error1['dates'] = '';
    this.setState({
      errors: error1,
    });
    const { value } = event.target;
    this.setState({
      daysInFuture: value,
    });
  };

  public onLengthofStayChange = (event) => {
    const error1 = this.state.errors;
    error1['dates'] = '';
    this.setState({
      errors: error1,
    });
    const { value } = event.target;
    this.setState({
      lengthOfStay: value,
    });
  };

  public handleStarRating = (event) => {
    const starRating1 = [...this.state.starRating];
    if (starRating1.includes(event.currentTarget.id)) {
      if (!event.currentTarget.checked) {
        const index = starRating1.indexOf(event.currentTarget.id);
        starRating1.splice(index, 1);
      }
    } else {
      if (event.currentTarget.checked) {
        starRating1.push(event.currentTarget.id);
      }
    }
    this.setState({
      starRating: starRating1,
    });
  };

  public handleAmenity = (event) => {
    if (event.currentTarget.id === 'all_amenity') {
      this.setState({
        allAmenity: event.currentTarget.checked,
        air_condition: event.currentTarget.checked,
        fitness: event.currentTarget.checked,
        speed: event.currentTarget.checked,
        all_inclusive: event.currentTarget.checked,
        parking: event.currentTarget.checked,
        pets: event.currentTarget.checked,
        business_services: event.currentTarget.checked,
        green: event.currentTarget.checked,
        room_services: event.currentTarget.checked,
        breakfast: event.currentTarget.checked,
        hairdryer: event.currentTarget.checked,
        spa: event.currentTarget.checked,
      });
    }
    this.setState({
      [event.currentTarget.id]: event.currentTarget.checked,
    });
  };

  public handleHotelId = (selection: TypeaheadSelection) => {
    const errors1 = this.state.errors;
    errors1['hotelId'] = '';
    this.setState({
      errors: errors1,
      message: '',
    });
    const { data, term } = selection as TypeaheadSelectionPropsHIS;
    this.setState({ hotelId: data['selected'] });
  };

  public render() {
    const roomComponent = (
      <RoomComponent
        onAdultCountChange={this.onAdultCountChange}
        onChildCountChange={this.onChildCountChange}
        roomCount="1"
        childComponent={this.state[`childComponent1`]}
      />
    );

    return (
      <>
        <UitkToast onCloseRef={this.onCloseRef} show={this.state.copyStatus} verticalOffset={200}>
          {this.state.copyMessage}
        </UitkToast>
        <div className="uitk-grid all-cell-1-1">
          <div className="uitk-cell">
            <div className="uitk-flex">
              <UitkHeading tag="h2" size={5}>
                Which Hotel are You Deeplinking To?
              </UitkHeading>
            </div>
            <UitkTypeahead
              adapter={
                new ESSAdapter({
                  client: 'lodging',
                  dest: true,
                  domain: 'https://www.expedia.com/',
                  expuserid: -1,
                  features: 'contextual_ta|postal_code|multiregion_parent|ta_hierarchy',
                  guid: '8cbe8b8bee5249e08c293ae5ec40abea', // you can switch this with your own guid but only works if user has serach history
                  lob: 'HOTELS',
                  locale: 'en_US',
                  maxResults: 10,
                  personalize: false, // change to true to see recent searches
                  regionType: 128,
                  siteId: 1,
                })
              }
              label="Select the Hotel"
              name="hotelLocation"
              icon="lob_hotels"
              onUpdate={this.handleHotelId}
            />
            <span style={{ color: 'red' }}>{this.state.errors['hotelId']}</span>
          </div>
        </div>
        <div className="uitk-grid all-y-margin-two">
          <div className="uitk-cell uitk-grid all-cell-1-1">
            <div className="uitk-cell">
              <hr className="dlb-separator-line" />
            </div>
          </div>
        </div>
        <div className="uitk-grid all-cell-1-1">
          <div className="uitk-cell">
            <UitkHeading tag="h2" size={5}>
              Select Your Dates
            </UitkHeading>
          </div>
        </div>
        <div className="uitk-grid all-cell-1-1">
          <div className="uitk-cell">
            <p>Create your deeplink by entering a specific date range or by searching 1-11 days in the future.</p>
          </div>
        </div>
        <div className="uitk-grid s-cell-1-1 m-cell-1-3 l-cell-1-4 xl-cell-1-4">
          <div className="uitk-cell">
            <UitkToggleSwitch
              id="hideDateField"
              checked={this.state.hideDateField}
              onChange={this.handleDateField}
              label="Pick Date Selection Type"
              labelClassName="uitk-type-500"
            />
          </div>
        </div>
        {this.state.hideDateField ? (
          <UitkLayoutFlex space="two">
            <>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkSelect id="days-in-future" label="Days in the future" onChange={this.onDaysInFutureChange}>
                    {this.renderDaysInFutureAndLengthOfStay()}
                  </UitkSelect>
                </div>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkSelect id="length-of-stay" label="Length of Stay" onChange={this.onLengthofStayChange}>
                    {this.renderDaysInFutureAndLengthOfStay()}
                  </UitkSelect>
                </div>
              </UitkLayoutFlexItem>
            </>
          </UitkLayoutFlex>
        ) : (
          <UitkLayoutFlex space="two">
            <>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkTextInput
                    id="startDate"
                    label="Check In"
                    placeholder="mm/dd/yyyy"
                    name="startDate"
                    value={this.state.startDate}
                    onChange={this.handleDatesChange}
                    invalid={this.validateDates('startDate')}
                    icon="today"
                  />
                </div>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkTextInput
                    id="endDate"
                    label="Check Out"
                    placeholder="mm/dd/yyyy"
                    name="endDate"
                    value={this.state.endDate}
                    onChange={this.handleDatesChange}
                    invalid={this.validateDates('endDate')}
                    icon="today"
                  />
                </div>
              </UitkLayoutFlexItem>
            </>
          </UitkLayoutFlex>
        )}
        <span style={{ color: 'red' }}>{this.state.errors['dates']}</span>

        <div className="uitk-grid all-y-margin-two">
          <div className="uitk-cell uitk-grid all-cell-1-1">
            <div className="uitk-cell">
              <hr className="dlb-separator-line" />
            </div>
          </div>
        </div>
        <div className="uitk-grid all-y-margin-two">
          <div className="uitk-cell uitk-grid all-cell-1-1">
            <div className="uitk-cell">
              <UitkHeading tag="h2" size={5}>
                Who is Travelling
              </UitkHeading>
            </div>
          </div>
        </div>
        <Viewport>
          <ViewLarge>
            <div className="uitk-grid all-y-margin-two">
              <div className="uitk-cell uitk-grid all-cell-1-2">
                <div className="uitk-cell">
                  <UitkSelect
                    id="room-count"
                    label=""
                    icon="room"
                    onChange={this.onRoomCountChange}
                    hasVisibleLabel={false}
                  >
                    {this.renderRoomCount()}
                  </UitkSelect>
                </div>
                <div className="uitk-cell uitk-grid all-x-gutter-one all-cell-1-3">
                  {roomComponent}
                  {this.state.roomStateChange ? this.state.roomComponents : ''}
                </div>
              </div>
            </div>
          </ViewLarge>
          <ViewSmall>
            <div className="uitk-grid all-cell-1-1 all-y-margin-two">
              <div className="uitk-cell all-b-margin-four">
                <UitkSelect
                  id="room-count"
                  label=""
                  icon="room"
                  onChange={this.onRoomCountChange}
                  hasVisibleLabel={false}
                >
                  {this.renderRoomCount()}
                </UitkSelect>
              </div>
              {roomComponent}
              <div className="uitk-cell">{this.state.roomStateChange ? this.state.roomComponents : ''}</div>
            </div>
          </ViewSmall>
        </Viewport>
        <div className="uitk-grid all-y-margin-two">
          <div className="uitk-cell">
            <UitkPrimaryButton name="buildlink" type="button" isFullWidth={true} onClick={this.handleClick}>
              Build Deeplink
            </UitkPrimaryButton>
          </div>
        </div>
        <div className="uitk-grid all-y-margin-two">
          <div className="uitk-cell">
            <UitkText align="left" size={500} weight="bold">
              Here is your Deeplink
            </UitkText>
            {this.state.isLoading ? (
              <Loader />
            ) : (
              <UitkTextArea id="deeplink_holder" label="" name="deeplink_holder" value={this.state.link} />
            )}
          </div>
        </div>
        <UitkSpacing margin={{ block: 'three' }}>
          <div>
            <UitkLayoutFlex space="three">
              <>
                <UitkPrimaryButton name="buildlink" type="button" onClick={this.copyToClipBoard}>
                  Copy Link
                </UitkPrimaryButton>
                <UitkPrimaryButton name="buildlink" type="button" onClick={this.handleUrlOpen}>
                  Test Link
                </UitkPrimaryButton>
              </>
            </UitkLayoutFlex>
          </div>
        </UitkSpacing>
      </>
    );
  }
  public componentWillUnMount() {
    setTimeout(() => this.setState({ message: '' }), 3000);
  }
  public componentDidUpdate() {
    setTimeout(() => this.setState({ copyStatus: false }), 4000);
  }
}
